<template>
  <div id="receive-detail">
    <b-breadcrumb>
      <b-breadcrumb-item text="รายการส่งตรวจ" @click="goReceivePage()" />
      <b-breadcrumb-item :text="data.name + ' AN ' + data.an" active />
    </b-breadcrumb>
    <div id="topic">รับส่งสิ่งตรวจ</div>
    <div id="sub-topic" class="left">
      LN - {{ order.ln }}
      <label
        v-if="order.status_id != 6"
        :class="{
          'text-red': order.emergency_level == 1 ? true : false,
          'text-orange':
            order.emergency_level == 1
              ? false
              : order.urgency_hospital_type == 'ปกติ'
              ? false
              : true,
          'ml-1': true,
        }"
      >
        {{
          order.emergency_level == 1
            ? "ด่วนพิเศษ " +
              `${order.sending_time ? "(" + order.sending_time + ")" : ""}`
            : order.urgency_hospital_type
        }}
      </label>
      <label v-else class="text-red">ยกเลิก ({{ order.cancel_reason }})</label>
      <br />
      <div class="order-date">
        <div>วันที่สั่งตรวจ :</div>
        <div class="input-datetime">
          <datetime
            v-model="dateNow"
            :input-class="{
              'form-control': true,
            }"
            type="date"
            class="theme-orange datepicker-trigger input-group"
            placeholder="Select Date"
            format="dd-MM-yyyy"
            value-zone="local"
            :disabled="order.status_id == 6"
          />
        </div>
        <div class="col-2">
          <datetime
            v-model="timeNow"
            :input-class="{
              'form-control': true,
            }"
            type="time"
            class="theme-orange datepicker-trigger input-group"
            placeholder="Select Time"
            format="HH:mm:ss"
            value-zone="local"
          />
        </div>
      </div>
    </div>
    <!-- <div id="sub-topic" class="left" v-else>
            LN - {{ items[0].ln }}
            <label class="text-red">
                ยกเลิก ({{ items[0].cancel_reason }})
            </label>
            <br />
            <div class="order-date">
                <div>วันที่สั่งตรวจ :</div>
                <div class="input-datetime">
                    <datetime
                        :input-class="{
                            'form-control': true
                        }"
                        v-model="dateNow"
                        type="date"
                        class="theme-orange datepicker-trigger input-group"
                        placeholder="Select Date"
                        format="dd-MM-yyyy"
                        :disabled="items[0].status_id == 6"
                    ></datetime>
                </div>
                <b-button
                    v-if="items[0].status_id != 6"
                    variant="success"
                    @click="updateOrderDate"
                    >บันทึก</b-button
                >
            </div>
    </div>-->
    <div class="form">
      <form novalidate>
        <div class="row text-bold">
          <div class="form-group left col-4">
            <label for="formGroupExampleInput">ชื่อสถานพยาบาล</label>
            <multiselect
              id="hospitalInput"
              v-model="hospitalSelectedObject"
              style="min-width: 200px;"
              deselect-label="✖"
              :options="hospitals"
              @input="setHospitalData"
            />
          </div>
          <div class="form-group left col-4">
            <label for="directionInput">เส้นทางวิ่ง</label>
            <input
              v-if="customerData.direction_info.direction"
              id="directionInput"
              v-model="customerData.direction_info.direction.direction"
              type="text"
              class="form-control"
              placeholder="Auto field"
              disabled
            />
            <input
              v-else
              v-model="customerData.direction_info.direction"
              type="text"
              class="form-control"
              placeholder="-"
              disabled
            />
          </div>
          <!--                        <input-->
          <!--                            type="text"-->
          <!--                            class="form-control"-->
          <!--                            id="formGroupExampleInput2"-->
          <!--                            v-model="data.hospital_name"-->
          <!--                            disabled-->
          <!--                        />-->
          <!--                    </div>-->
          <!--                    <div class="form-group left col-4">-->
          <!--                        <label for="formGroupExampleInput2">เส้นทางวิ่ง</label>-->
          <!--                        <input-->
          <!--                            v-if="customerData.direction_info.direction"-->
          <!--                            type="text"-->
          <!--                            class="form-control"-->
          <!--                            id="formGroupExampleInput2"-->
          <!--                            v-model="-->
          <!--                                customerData.direction_info.direction.direction-->
          <!--                            "-->
          <!--                            disabled-->
          <!--                        />-->
          <!--                        <input-->
          <!--                            v-else-->
          <!--                            type="text"-->
          <!--                            class="form-control"-->
          <!--                            id="formGroupExampleInput2"-->
          <!--                            placeholder="-"-->
          <!--                            v-model="customerData.direction_info.direction"-->
          <!--                            disabled-->
          <!--                        />-->
          <!--                    </div>-->
          <div class="form-group left col-4">
            <label for="anInput">AN</label>
            <input
              id="anInput"
              v-model="data.an"
              type="text"
              class="form-control"
              required
              disabled
            />
            <!-- <label for="formGroupExampleInput2">ชื่อ-สกุลเจ้าของ</label>
            <input
              id="formGroupExampleInput2"
              v-model="data.owner_name"
              type="text"
              class="form-control"
            /> -->
          </div>
        </div>
        <div class="row text-bold">
          <div class="form-group left col-4">
            <label for="formGroupExampleInput">ชื่อสัตว์</label>
            <input
              id="formGroupExampleInput"
              v-model="data.name"
              type="text"
              class="form-control"
              placeholder="Enter name"
            />
          </div>
          <div class="form-group left col-4">
            <label for="formGroupExampleInput">Species</label>
            <multiselect
              id="speciesInput"
              v-model="data.species"
              style="min-width: 200px;"
              select-label
              deselect-label
              selected-label
              label="species_name"
              track-by="id"
              :allow-empty="false"
              :options="species"
              @input="changeValue"
            />
            <template v-if="data.species">
              <div style="margin-top: 1rem;">
                <b-form-input
                  v-if="
                    data.species ? data.species.species_name === 'อื่นๆ' : false
                  "
                  v-model="data.other_specie"
                  placeholder="สปีชีส์อื่นๆ"
                />
              </div>
            </template>
          </div>
          <div class="form-group left col-4">
            <label for="formGroupExampleInput">สายพันธุ์</label>
            <multiselect
              id="breed-2-input"
              v-model="data.breed"
              style="min-width: 200px;"
              select-label
              deselect-label
              selected-label
              label="breed_name"
              track-by="id"
              :options="breedsComputed"
              :allow-empty="false"
              @input="changeValue"
            />
            <div style="margin-top: 1rem;">
              <b-form-input
                v-if="data.breed ? data.breed.breed_name === 'อื่นๆ' : false"
                v-model="data.other_breed"
                placeholder="สายพันธ์อื่นๆ"
              />
            </div>
          </div>
        </div>
        <div class="row text-bold">
          <div class="form-group left col-4">
            <label for="formGroupExampleInput2">เพศ</label>
            <multiselect
              id="genderInput"
              v-model="data.gender.gender_name"
              style="min-width: 200px;"
              select-label
              deselect-label="✖"
              selected-label
              :options="lstGenders"
            />
          </div>
          <div class="form-group left col-4">
            <label for="formGroupExampleInput2" style="display:flex"
              >อายุ (ปี/เดือน/วัน)</label
            >
            <div class="row">
              <div class="col age">
                <input
                  id="formGroupExampleInput2"
                  v-model="form_age.year"
                  type="text"
                  class="form-control"
                  placeholder="-"
                />
              </div>
              <div class="col age">
                <!--
                                            <label for="formGroupExampleInput2"></label>
                    -->
                <input
                  id="formGroupExampleInput2"
                  v-model="form_age.month"
                  type="text"
                  class="form-control"
                  placeholder="-"
                />
              </div>
              <div class="col">
                <!--
                                            <label for="formGroupExampleInput2"></label>
                    -->
                <input
                  id="formGroupExampleInput2"
                  v-model="form_age.day"
                  type="text"
                  class="form-control"
                  placeholder="-"
                />
              </div>
            </div>
          </div>
          <div class="form-group left col-4">
            <label for="formGroupExampleInput2">HN</label>
            <input
              id="formGroupExampleInput2"
              v-model="data.hn"
              type="text"
              class="form-control"
              placeholder="Enter HN"
            />
          </div>
        </div>
        <div class="row text-bold">
          <div class="form-group left col-2">
            <label for="titleNameInput">คำนำหน้า</label>
            <multiselect
              id="titleNameInput"
              v-model="data.owner_title_name"
              style="min-width: 200px;"
              select-label
              deselect-label
              selected-label
              label="name"
              track-by="id"
              :allow-empty="false"
              :options="ownerTitleNames"
              @input="changeValue"
            />
          </div>
          <div class="form-group left col-5">
            <label for="ownerInput">ชื่อ-สกุลเจ้าของ</label>
            <input
              id="ownerInput"
              v-model="data.owner_name"
              type="text"
              class="form-control"
              placeholder="Enter Owner Name"
            />
          </div>
          <div class="form-group left col-5">
            <label for="noteInput">บ้านเลขที่</label>
            <input
              id="doctorInput"
              v-model="data.owner_address"
              type="text"
              class="form-control"
              placeholder="Enter Address"
            />
          </div>
        </div>
        <div class="row text-bold">
          <div class="form-group left col-6">
            <label for="formGroupExampleInput2">ชื่อแพทย์</label>
            <input
              id="doctorInput"
              v-model="data.doctor_name"
              type="text"
              class="form-control"
            />
          </div>
          <div class="form-group left col-6">
            <label for="formGroupExampleInput2">Note</label>
            <input
              id="formGroupExampleInput2"
              v-model="data.note"
              type="text"
              class="form-control"
            />
          </div>
        </div>
        <div class="text-right">
          <b-button
            v-if="order.status_id != 6"
            variant="success"
            @click="updateOrderDate"
            >บันทึก</b-button
          >
        </div>
      </form>
    </div>
    <div>รายการตรวจ</div>
    <div class="form">
      <b-table
        responsive
        :fields="fields"
        :items="order.test_order"
        :sort-by.sync="sortBy"
        :sort-direction="sortDirection"
        striped
      >
        <!-- A virtual column -->
        <template slot="barcode" slot-scope="data">
          <div class="col-right">{{ data.item.barcode }}</div>
        </template>
        <!-- A custom formatted column -->
        <template slot="specimenType" slot-scope="data">
          <div class="col-left">{{ data.item.specimen_type_name }}</div>
        </template>
        <!-- A virtual composite column -->
        <template slot="testType" slot-scope="data">
          <div class="col-left">{{ data.item.test_type_name }}</div>
        </template>
        <template slot="test" slot-scope="data">
          <div class="col-left">{{ data.item.test_name }}</div>
        </template>
        <template slot="remark" slot-scope="data">
          <div class="col-left">{{ data.item.remark }}</div>
        </template>
        <template slot="machine" slot-scope="data">
          <div class="col-left">{{ data.item.machine_name.join(", ") }}</div>
        </template>
        <!-- <template slot="delete" slot-scope="data">
                    <a v-b-modal="'myModal'">
                        <fa-icon :icon="['fas', 'times']" class="icon" />
                    </a>
        </template>-->
      </b-table>
      <div v-if="order.status_id != 6" class="right">
        <b-btn v-b-modal="'myModal'">ยกเลิก</b-btn>&nbsp;
        <b-btn v-b-modal="'receiveModal'" variant="success"
          >รับสิ่งส่งตรวจและพิมพ์บาร์โค้ด</b-btn
        >
      </div>
      <br />
    </div>
    <div class="text-left">
      <table class="table history-table text-left">
        <tr>
          <th>สร้างโดย</th>
          <th>แก้ไขล่าสุดโดย</th>
          <th>รับสิ่งตรวจโดย</th>
          <th>Record ล่าสุดโดย</th>
          <th>รายงานผลล่าสุดโดย</th>
          <th>Approve ล่าสุดโดย</th>
          <th>ยกเลิกโดย</th>
          <th>Reject โดย</th>
        </tr>
        <tr>
          <td>{{ order.createdBy ? order.createdBy.name : "-" }}</td>
          <td>{{ order.updatedBy ? order.updatedBy.name : "-" }}</td>
          <td>
            {{
              order.latestReceivedBy ? order.latestReceivedBy.user.name : "-"
            }}
          </td>
          <td>
            {{
              order.latestRecordedBy ? order.latestRecordedBy.user.name : "-"
            }}
          </td>
          <td>
            {{
              order.latestReportedBy ? order.latestReportedBy.user.name : "-"
            }}
          </td>
          <td>
            {{
              order.latestApproveUser ? order.latestApproveUser.user.name : "-"
            }}
          </td>
          <td>
            {{
              order.latestCanceledBy ? order.latestCanceledBy.user.name : "-"
            }}
          </td>
          <td>
            {{
              order.latestRejectedBy ? order.latestRejectedBy.user.name : "-"
            }}
          </td>
        </tr>
        <tr>
          <td>{{ order.created_at ? order.created_at : "-" }}</td>
          <td>{{ order.updated_at ? order.updated_at : "-" }}</td>
          <td>
            {{
              order.latestReceivedBy ? order.latestReceivedBy.created_at : "-"
            }}
          </td>
          <td>
            {{
              order.latestRecordedBy ? order.latestRecordedBy.created_at : "-"
            }}
          </td>
          <td>
            {{
              order.latestReportedBy ? order.latestReportedBy.created_at : "-"
            }}
          </td>
          <td>
            {{
              order.latestApproveUser ? order.latestApproveUser.created_at : "-"
            }}
          </td>
          <td>
            {{
              order.latestCanceledBy ? order.latestCanceledBy.created_at : "-"
            }}
          </td>
          <td>
            {{
              order.latestRejectedBy ? order.latestRejectedBy.created_at : "-"
            }}
          </td>
        </tr>
      </table>
    </div>
    <template v-if="listBarcode != []">
      <template v-for="barcode in listBarcode">
        <img v-show="false" :id="'barcode' + barcode" :key="barcode.index" />
      </template>
    </template>
    <!-- when รับสิ่งตรวจ -->
    <b-modal id="receiveModal" ref="receiveModal" hide-header hide-footer>
      <div style="text-align: center;">
        <h4>คุณต้องการรับสิ่งส่งตรวจและพิมพ์บาร์โค้ด?</h4>
        <br />
        <b-button variant="secondary" @click="hideReceiveModal">ยกเลิก</b-button
        >&nbsp;
        <b-button class="primary-btn" variant="success" @click="updateStatus"
          >ตกลง</b-button
        >
      </div>
    </b-modal>
    <!-- when cancel -->
    <b-modal
      id="myModal"
      ref="cancelModal"
      centered
      title="ยกเลิกสิ่งตรวจ"
      ok-variant="success"
      ok-title="บันทึก"
      cancel-title="ยกเลิก"
      @ok="handleOk"
      @shown="clearReasonSelect"
    >
      <div class="modal-body">
        <form>
          <div class="form-group">
            <label for="sel1" class="col-form-label left" style="width:100%;"
              >เหตุผล:</label
            >
            <select id="sel1" v-model="reasonSelect" class="form-control">
              <option value disabled hidden selected>โปรดเลือก</option>
              <option value="ลูกค้าขอยกเลิก">ลูกค้าขอยกเลิก</option>
              <option value="อื่นๆ">อื่นๆ</option>
            </select>
          </div>
          <div v-show="reasonSelect == 'อื่นๆ'" class="form-group">
            <label
              for="message-text"
              class="col-form-label left"
              style="width:100%;"
              >อื่นๆโปรดระบุ :</label
            >
            <textarea id="message-text" v-model="reason" class="form-control" />
          </div>
        </form>
      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn class="float-right ml-2" variant="success" @click="handleOk"
          >ยืนยัน</b-btn
        >
        <b-btn class="float-right" variant="secondary" @click="hideCancelModal"
          >ยกเลิก</b-btn
        >
      </div>
    </b-modal>
    <notifications group="alert" position="bottom right" />
  </div>
</template>
<script>
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import moment from "moment-timezone";
// import moment from 'moment'
import { mapGetters, mapActions } from "vuex";
import { createPage, createCover } from "../../utils/BarcodeCreate";

export default {
  props: ["read", "autoreceive"],
  data() {
    return {
      fields: [
        // A virtual column that doesn't exist in items
        { key: "barcode", label: "บาร์โค้ด" },
        // A column that needs custom formatting
        { key: "specimenType", label: "SPECIMEN TYPE" },
        { key: "testType", label: "ประเภทสิ่งตรวจ" },
        { key: "test", label: "รายการตรวจ" },
        { key: "remark", label: "REMARK" },
        { key: "machine", label: "เครื่องตรวจ" },
        { key: "delete", label: "" },
      ],
      sortDirection: "asc",
      sortBy: "barcode",
      form_age: {
        year: null,
        month: null,
        day: null,
      },
      listBarcode: [],
      reasonSelect: "",
      reason: "",
      dateNow: "",
      timeNow: "",
      lstHospitals: [],
      lstGenders: [],
      objGenders: [],
      objHospitals: [],
      ownerTitleNames: [],
      order: null,
      hospitalSelectedObject: null,
    };
  },
  async created() {
    this.$nextTick(() => {
      this.setHospitals();
    });
  },
  async mounted() {
    const orderId = this.items[0].id;
    this.order = await this.getOrderDetail(orderId);
    this.form_age.year = this.setYear(this.data.age);
    this.form_age.month = this.setMonth(this.data.age);
    this.form_age.day = this.setDay(this.data.age);
    await this.setListBarcode();
    await this.setGenders();
    // console.log(this.items[0].order_date)
    this.dateNow = this.items[0].order_date;
    this.timeNow = moment(this.items[0].order_date_time).format();

    const getOwnerTitleNames = await this.getOwnerTitleNames();

    this.ownerTitleNames = [
      { id: null, name: "ไม่ระบุ" },
      ...getOwnerTitleNames.title,
    ];

    if (!this.data.owner_title_name) {
      this.data.owner_title_name = this.ownerTitleNames[0];
    }

    if (this.autoreceive) {
      await this.updateStatus();
    }
  },
  computed: {
    ...mapGetters({
      items: "Order/getOrder",
      data: "Animal/getData",
      customerData: "Hospital/getData",
      readOnly: "Order/getReadOnly",
      hospitals: "Hospital/getAll",
      genders: "Gender/getAll",
      species: "Species/getAll",
      breeds: "Breed/getAll",
    }),
    breedsComputed() {
      let specie = this.data.species;
      if (!specie) {
        return this.breeds;
      }
      return this.breeds.filter(
        (breed) => breed.species_id === specie.id || breed.species_id === null,
      );
    },
  },
  watch: {
    dateNow(value) {},
  },
  methods: {
    ...mapActions({
      getOwnerTitleNames: "Animal/getOwnerTitleName",
      updateOrder: "Order/updateOrder",
      checkReceivePermission: "Order/checkPermission",
      setCustomerData: "Hospital/setData",
      getOrderDetail: "Order/getOrderDetail",
    }),
    setGenders() {
      const array = [];
      const obj = [];
      // console.log(this.genders);
      this.genders.forEach((element) => {
        array.push(element.gender_name);
        obj[element.gender_name] = element.id;
      });
      this.lstGenders = array;
      this.objGenders = obj;
    },
    changeValue(val) {
      this.$store.state.isEditing = true;
    },
    async setHospitals() {
      const array = [];
      const obj = [];
      await this.hospitals.forEach((element) => {
        array.push(element.name);
        obj[element.name] = element.id;
      });
      this.lstHospitals = array;
      this.objHospitals = obj;
      this.hospitalSelectedObject = this.hospitals.find(
        (hospital) => hospital.id == this.data.hospital_id,
      );
    },
    async permission(type, mod) {
      let permission = await this.checkPermission({
        type: type,
        mod: mod,
      });

      if (!permission) {
        this.$notify({
          group: "alert",
          title: "มีข้อผิดพลาดบางอย่าง",
          text: permission,
          position: "bottom right",
          type: "error",
        });
        return false;
      }
      return true;
    },
    // cancel order
    async updateOrderDate() {
      if (this.$store.state.isLoading) {
        return;
      }
      this.$store.state.isLoading = true;
      let permission = await this.checkPermission("receive_order", "can_edit");

      if (permission) {
        const payload = {
          id: this.items[0].id,
          order_date: moment(this.dateNow).format("YYYY-MM-DD"),
          order_date_time:
            moment(this.dateNow).format("YYYY-MM-DD") +
            " " +
            moment(this.timeNow).format("HH:mm:ss"),
          note: this.data.note,
          doctor_name: this.data.doctor_name,
          hospital_id: this.data.hospital_id,
          name: this.data.name,
          owner_name: this.data.owner_name,
          owner_surname: this.data.owner_surname,
          owner_address: this.data.owner_address,
          owner_title_name: this.data.owner_title_name,
          hn: this.data.hn,
          age:
            this.form_age.year +
            "-" +
            this.form_age.month +
            "-" +
            this.form_age.day,
          sex: this.objGenders[this.data.gender.gender_name]
            ? this.objGenders[this.data.gender.gender_name]
            : 3,
          breed_id: this.data.breed ? this.data.breed.id : 1,
          species_id: this.data.species ? this.data.species.id : 1,
          other_specie: this.data.other_specie,
          other_breed: this.data.other_breed,
        };
        // console.log(payload)
        await this.updateOrder(payload);
        this.$swal.fire("บันทึกสำเร็จ", "บันทึกเรียบร้อยแล้ว", "success");
        this.$store.state.isLoading = false;
      }
      this.$store.state.isLoading = false;
    },
    async setHospitalData(value) {
      this.data.hospital_name = value.name;
      this.data.hospital_id = value.id;
      // const id = this.objHospitals[this.data.hospital_name]
      //   ? this.objHospitals[this.data.hospital_name]
      //   : "";
      this.$store.state.isLoading = true;
      await this.setCustomerData(value.id);
      this.$store.state.isLoading = false;
    },
    async handleOk() {
      if (this.$store.state.isLoading) {
        return;
      }
      this.$store.state.isLoading = true;
      let permission = await this.checkPermission(
        "receive_order",
        "can_cancel",
      );

      if (permission) {
        if (this.reasonSelect == "") {
          this.$swal.fire("เกิดข้อผิดพลาด", "โปรดเลือกเหตุผล", "error");
          this.$store.state.isLoading = false;
        } else {
          if (this.reasonSelect == "อื่นๆ" && this.reason == "") {
            this.$swal.fire("เกิดข้อผิดพลาด", "โปรดระบุเหตุผล", "error");
            this.$store.state.isLoading = false;
          } else {
            const payload = {
              id: this.items[0].id,
              status: "6",
              cancel_reason:
                this.reasonSelect == "อื่นๆ" ? this.reason : this.reasonSelect,
            };
            await this.updateOrder(payload);
            this.$router.push({ name: "receive" });
            this.$store.state.isLoading = false;
          }
        }
      }
      this.$store.state.isLoading = false;
    },
    goReceivePage() {
      this.$router.push({ name: "receive" });
    },
    setYear(date) {
      if (!date) {
        return "";
      }
      var array = date.split("-");
      if (array[0] === undefined) {
        return "";
      }
      return array[0];
    },
    setMonth(date) {
      if (!date) {
        return "";
      }

      var array = date.split("-");
      if (array[1] === undefined) {
        return "";
      }
      return array[1];
    },
    setDay(date) {
      if (!date) {
        return "";
      }
      var array = date.split("-");
      if (array[2] === undefined) {
        return "";
      }
      return array[2];
    },
    async exportPdf(order) {
      // var doc = new jsPDF({
      //     orientation: "landscape",
      //     unit: "cm",
      //     format: [170.079, 99.2126]
      // });
      this.$store.state.isLoading = true;
      var BreakException = {};
      function getBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });
      }

      let pFont = fetch("/Kanit-Regular.ttf")
        .then((response) => response.blob())
        .then((response) => getBase64(response))
        .then((response) => {
          if (!response) {
            return "";
          }
          return response.split(",")[1];
        });

      let pClass = jsPDF;

      Promise.all([pFont, pClass]).then(([font, jsPDF]) => {
        var doc = new jsPDF({
          orientation: "landscape",
          unit: "cm",
          format: [170.079, 99.2126],
        });
        doc.addFileToVFS("/Kanit-Regular.ttf", font);
        doc.addFont("/Kanit-Regular.ttf", "font", "normal");
        doc.setFont("font");
        doc.setFontStyle("normal");
        var width = doc.internal.pageSize.getWidth() - 3;
        var height = doc.internal.pageSize.getHeight() - 1.75;
        for (let index = 0; index < this.listBarcode.length; index++) {
          const img = document.querySelector(
            "img#barcode" + this.listBarcode[index],
          );
          this.items[0].daily_number = order.daily_number;
          if (index == 0) {
            doc = createCover(
              index,
              doc,
              this.data,
              this.items[0],
              this.listBarcode,
              BreakException,
            );

            doc = createPage(
              img,
              index,
              doc,
              this.data,
              this.items[0],
              this.listBarcode,
              width,
              height,
              BreakException,
            );
          } else {
            doc = createPage(
              img,
              index,
              doc,
              this.data,
              this.items[0],
              this.listBarcode,
              width,
              height,
              BreakException,
            );
          }
        }
        // doc.save('barcode.pdf');
        // doc.autoPrint();
        // doc.output("dataurlnewwindow");
        this.$store.state.isLoading = false;
        // doc.output("dataurlnewwindow");
        const blob = doc.output("blob");
        const url = URL.createObjectURL(blob);

        // สร้างลิงก์ชั่วคราวเพื่อเปิดหรือดาวน์โหลด
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank"; // เปิดหน้าใหม่เพื่อ Print
        link.click();

        // สำคัญ: ต้อง clean up memory หลังจากใช้งานเสร็จ
        setTimeout(() => URL.revokeObjectURL(url), 100);
        if (this.autoreceive) {
          this.goReceivePage();
        } else {
          this.$router.push({ name: "result" });
        }

        // window.open(doc.output('dataurlnewwindow')).focus();
      });
    },
    async updateStatus() {
      if (this.$store.state.isLoading) {
        return;
      }
      this.$store.state.isLoading = true;
      let permission = await this.checkPermission(
        "receive_order",
        "can_receive",
      );
      this.$store.state.isLoading = false;

      if (permission) {
        this.hideReceiveModal();
        const payload = {
          id: this.items[0].id,
          status: "2",
          receive: "true",
          cancel_reason: "",
        };
        this.$store.state.isLoading = true;
        let order = await this.updateOrder(payload);
        this.$store.state.isLoading = false;
        await this.exportPdf(order);
      }
    },
    async setListBarcode() {
      this.listBarcode = [];
      await this.items[0].test_order.forEach((element) => {
        if (!this.listBarcode.includes(element.barcode)) {
          this.listBarcode.push(element.barcode);
        }
      });
      this.listBarcode.forEach((element) => {
        JsBarcode("#barcode" + element, element, {
          displayValue: false,
        });
      });
    },
    clearReasonSelect() {
      this.reasonSelect = "";
    },
    hideReceiveModal() {
      this.$refs.receiveModal.hide();
    },
    hideCancelModal() {
      this.$refs.cancelModal.hide();
    },
    async checkPermission(type, mod) {
      let permission = await this.checkReceivePermission({
        type: type,
        mod: mod,
      });

      if (!permission) {
        this.$notify({
          group: "alert",
          title: "มีข้อผิดพลาดบางอย่าง",
          text: permission,
          position: "bottom right",
          type: "error",
        });
        return false;
      }
      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
#receive-detail {
  width: 92vw;
  margin: 0 auto;
  margin-top: 20px;
}
#topic {
  text-align: left;
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 20px;
  color: #2f3438;
}
#sub-topic {
  font-weight: bold;
  margin: 20px;
  margin-left: 60px;
}
.left {
  text-align: left;
}
.form {
  width: 80vw;
  margin: 0 auto;
}
.age {
  padding-right: 0px;
}
.text-red {
  color: red;
}
.text-orange {
  color: orange;
}
.icon {
  cursor: pointer;
}
.right {
  text-align: right;
}
.order-date {
  display: flex;
  align-items: center;
}
.input-datetime {
  width: 108px;
  margin-left: 5px;
  margin-right: 5px;
}

.text-bold {
  font-weight: bold;
}

.history-table {
  tr {
    td {
      text-align: center;
    }
  }

  th,
  td {
    text-align: left;
    padding: 8px;
    border: 1px solid white;
    border-top: 0px;
  }
  tr:nth-child(even) {
    background-color: #f2f2f2;
  }
  th {
    /* padding-top: 12px;
  padding-bottom: 12px; */
    text-align: center;
    background-color: rgb(219, 219, 219);
    color: #6b757f;
  }
}
</style>
